export default class SelectionManager {
  constructor() {
    this.selectedElements = new Set();
  }

  selectElement(element, addToSelection = false) {
    if (!addToSelection) {
      this.selectedElements.forEach(el => el.classList.remove('selected'));
      this.selectedElements.clear();
    }

    this.selectedElements.add(element);
    element.classList.add('selected');

    document.dispatchEvent(new CustomEvent('promote:canvas--selectionChanged'));
  }

  selectMultiple(elements) {
    this.selectedElements.forEach(el => el.classList.remove('selected'));
    this.selectedElements.clear();

    elements.forEach(element => {
      this.selectedElements.add(element);
      element.classList.add('selected');
    });

    if (elements.length > 0) {
      document.dispatchEvent(new CustomEvent('promote:canvas--selectionChanged'));
    }
  }

  deselectElement(element) {
    element.classList.remove('selected');
    this.selectedElements.delete(element);
    this._dispatchSelectionEvent();
  }

  deselectAll() {
    this.selectedElements.forEach(el => el.classList.remove('selected'));
    this.selectedElements.clear();
    document.dispatchEvent(new CustomEvent('promote:canvas--selectionCleared'));
  }

  getSelectedElements() {
    return Array.from(this.selectedElements);
  }

  hasSelection() {
    return this.selectedElements.size > 0;
  }

  hasMultipleSelected() {
    return this.selectedElements.size > 1;
  }

  isSelected(element) {
    return this.selectedElements.has(element);
  }

  _dispatchSelectionEvent() {
    const eventName = this.selectedElements.size > 0
      ? 'promote:canvas--selectionChanged'
      : 'promote:canvas--selectionCleared';

    document.dispatchEvent(new CustomEvent(eventName));
  }
}
